import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section1").offset().top - $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section1").offset().top - $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

var factory = new Swiper('.section5 .mySwiper', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '1.21%',
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.21%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1.21%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    },
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",              
    },
});


$(".section7 ul li .ask").click(function() {
    $(this).toggleClass('active');
    $(this).parent().find(".answer").slideToggle();
})